module.exports = new __parcel__URL__("second_tab_content_ko.3868c099.webp").toString();